import { JSONTransformer } from '@atlaskit/editor-json-transformer';
export var convertSyncBlockPMNodeToSyncBlockData = function convertSyncBlockPMNodeToSyncBlockData(node) {
  var includeContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var transformer = new JSONTransformer();
  var toJSON = function toJSON(node) {
    return transformer.encodeNode(node);
  };
  return {
    type: 'syncBlock',
    attrs: {
      localId: node.attrs.localId,
      resourceId: node.attrs.resourceId
    },
    content: includeContent ? node.content.content.map(toJSON) : undefined
  };
};
export var generateSyncBlockSourceUrl = function generateSyncBlockSourceUrl(node) {
  var _node$attrs = node.attrs,
    localId = _node$attrs.localId,
    resourceId = _node$attrs.resourceId;
  // TODO: EDITOR-1644 - To be implemented under EDITOR-1644
  // below is a temporary implementation for the url generation
  var url = new URL(location.origin + location.pathname);
  url.searchParams.set('localId', localId);
  url.searchParams.set('resourceId', resourceId);
  return url.toString();
};